import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import { COLOR } from 'assets/styles/colors';
// import BREAKPOINT from 'assets/styles/breakpoints';

export const StyledDialog = withStyles(() => ({
  paper: {
    margin: 18,
  },
  paperWidthSm: {
    width: '100%',
    maxWidth: 588,
  },
  paperScrollPaper: {
    flexDirection: 'row',
  },
}))(Dialog);

export const Content = styled.section`
  position: relative;
  width: 100%;
  padding: 45px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  button {
    font-size: 16px;
  }

  > button {
    color: ${COLOR.GREEN_1};
    width: 100%;
    margin: 0;
    font-size: 18px;
    
    :hover {
      background: none;
      box-shadow: none;
    }
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > h5 {
    font-weight: 700;
    font-size: 18px;
  }

  > button {
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 16px;
    border: none;
    background: none;
    padding: 0;

    > svg {
      fill: ${COLOR.GREEN_1};
    }
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Card = styled.div`
  padding: 8px;
  border: 1px solid ${COLOR.GREEN_1};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > button {
    width: 100%;
    margin: 0px !important;
  }
`;

export const CardRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
`;

export const CircularCardNumber = styled.div`
  background-color: ${COLOR.GREEN_1};
  color: ${COLOR.WHITE_1};
  height: 28px;
  width: 28px !important;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 700;
`;
